/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeletePromptResponse = {
  /**
   * The deleted prompt ID
   */
  id: string;
  /**
   * Object type
   */
  object: "prompt.deleted";
  /**
   * Deletion confirmation
   */
  deleted: true;
};

/** @internal */
export const DeletePromptResponse$inboundSchema: z.ZodType<
  DeletePromptResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("prompt.deleted"),
  deleted: z.literal(true),
});
/** @internal */
export type DeletePromptResponse$Outbound = {
  id: string;
  object: "prompt.deleted";
  deleted: true;
};

/** @internal */
export const DeletePromptResponse$outboundSchema: z.ZodType<
  DeletePromptResponse$Outbound,
  z.ZodTypeDef,
  DeletePromptResponse
> = z.object({
  id: z.string(),
  object: z.literal("prompt.deleted"),
  deleted: z.literal(true),
});

export function deletePromptResponseToJSON(
  deletePromptResponse: DeletePromptResponse,
): string {
  return JSON.stringify(
    DeletePromptResponse$outboundSchema.parse(deletePromptResponse),
  );
}
export function deletePromptResponseFromJSON(
  jsonString: string,
): SafeParseResult<DeletePromptResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeletePromptResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeletePromptResponse' from JSON`,
  );
}
